import { ReactNode } from 'react';
import { useRole } from '@/hooks/useRole';
import { Container } from '@/components/common';
import { PageBanner, PageBannerProps } from '@/components/common/PageBanner';
import styles from './TransactionsPageTemplate.module.css';
import { TransactionsPageTemplateControls } from './TransactionsPageTemplateControls';

interface TransactionsPageTemplateProps extends PageBannerProps {
  children?: ReactNode;
  tabs: { link: string; name: string }[];
}

export const TransactionsPageTemplate = ({
  children,
  tabs,
  buttonLabel,
  title,
  gradientSrc,
  variants,
  description,
}: TransactionsPageTemplateProps) => {
  const role = useRole();

  return (
    <div className={styles.page}>
      <Container className={styles.container}>
        <div className={styles.bannerWrapper}>
          <PageBanner
            buttonLabel={buttonLabel}
            title={title}
            gradientSrc={gradientSrc}
            variants={variants}
            description={description}
          />
        </div>
        <TransactionsPageTemplateControls tabs={tabs} role={role} />
        <div>{children}</div>
      </Container>
    </div>
  );
};
